export const profileKeys = {
  all: ['profile'] as const,
  myProfile: () => [...profileKeys.all, 'my'] as const,
  userProfile: (userId: string) => [...profileKeys.all, 'user', userId] as const,
};
